
import React from 'react';

import styles from './styles.module.scss'
import { useIsBoiWebsite } from "../../Context/WebsiteType";

interface IOptionText {
  text: string;
  selected: boolean;
  onClick: (option: string) => void;
}

export default function OptionText({ text, selected, onClick } : IOptionText) {

  const isBoiWebsite = useIsBoiWebsite();

  return (
    <div className={styles.optionText} onClick={() => onClick(text)}>
      <p>{ text }</p>
      <div className={`${isBoiWebsite ? styles.underlineBoi : styles.underline} ${selected && (isBoiWebsite ? styles.selectedBoi : styles.selected)}`}>&nbsp;</div>
    </div>
  )
};
